// Rappel doux quotidien via l'API Notification.
// Limite honnête : sans push serveur ni Periodic Background Sync validé sur iOS,
// la notification n'est déclenchée que lorsque l'application est ouverte au moment prévu,
// ou dès sa réouverture après l'heure choisie.

const KEY_TIME = "softlanding.reminder.time.v1";
const KEY_LAST = "softlanding.reminder.last.v1";
const KEY_ENABLED = "softlanding.reminder.enabled.v1";

export function isNotificationSupported() {
  return typeof window !== "undefined" && "Notification" in window;
}

export async function requestPermission() {
  if (!isNotificationSupported()) return "unsupported";
  try {
    const p = await Notification.requestPermission();
    return p;
  } catch { return "denied"; }
}

export function getPermission() {
  if (!isNotificationSupported()) return "unsupported";
  return Notification.permission;
}

export function getReminderConfig() {
  return {
    enabled: safe(KEY_ENABLED, false),
    time: safe(KEY_TIME, "20:00"),
  };
}

export function setReminderConfig({ enabled, time }) {
  localStorage.setItem(KEY_ENABLED, JSON.stringify(!!enabled));
  if (time) localStorage.setItem(KEY_TIME, JSON.stringify(time));
}

function safe(k, fb) {
  try { const v = localStorage.getItem(k); return v ? JSON.parse(v) : fb; } catch { return fb; }
}

function todayKey() {
  const d = new Date();
  return `${d.getFullYear()}-${d.getMonth()}-${d.getDate()}`;
}

export function fireIfDue() {
  if (!isNotificationSupported() || Notification.permission !== "granted") return false;
  const cfg = getReminderConfig();
  if (!cfg.enabled) return false;
  const last = safe(KEY_LAST, "");
  if (last === todayKey()) return false;
  const [h, m] = cfg.time.split(":").map(Number);
  const now = new Date();
  const target = new Date();
  target.setHours(h || 20, m || 0, 0, 0);
  if (now >= target) {
    try {
      new Notification("Soft Landing ASMR", {
        body: "Un moment pour retrouver le calme.",
        icon: "/manifest.json",
        silent: true,
        tag: "softlanding-daily",
      });
      localStorage.setItem(KEY_LAST, JSON.stringify(todayKey()));
      return true;
    } catch { return false; }
  }
  return false;
}

let timerId = null;
export function startScheduler() {
  stopScheduler();
  // Vérifie au démarrage puis chaque minute pendant que l'app est ouverte
  fireIfDue();
  timerId = setInterval(fireIfDue, 60 * 1000);
}
export function stopScheduler() {
  if (timerId) { clearInterval(timerId); timerId = null; }
}
